// extracted by mini-css-extract-plugin
module.exports = {"s1a4d69t":"s1a4d69t"};